import router from '@/router/router';
import * as types from '@/store/mutationTypes';
import {initialState} from '@/store/initialState';
import {UserPermissions} from '@/utils/userInfo';
import registrationService from '@/http/services/registrationService';
import authenticationService from '@/http/services/authenticationService';

export const actions = {
    logIn: async ({ commit }, payload) => {
        const userInfo = await authenticationService.logIn(payload);

        commit(types.SET_LOGGED_IN, true);
        commit(types.SET_USER_INFO, userInfo);

        UserPermissions.setUserInfoToLocalStorage(userInfo);

        const activityInfo = JSON.parse(localStorage.getItem('activity-info'));

        const query = JSON.parse(localStorage.getItem('query'));
        const routeName = JSON.parse(localStorage.getItem('route-name'));

        if (query && query.roster) {

            if (routeName) {
                router.push({ name: routeName, params: router.currentRoute.params, query: query });
            } else {
                router.push({ name: 'ACTIVITIES', params: router.currentRoute.params, query: query });
            }
        } else {
            activityInfo
            ? router.push({ name: 'ACTIVITIES', params: router.currentRoute.params, query: { activityType: activityInfo.activityType, search: activityInfo.search }})
            : router.push({ name: 'LAYOUT', params: router.currentRoute.params })
        }
    },

    registerParent: async ({ commit, dispatch }, payload) => {
        await registrationService.signUp(payload);

        localStorage.setItem('user-name', payload.email);
        router.push({ name: 'CONFIRM_REGISTRATION', params: router.currentRoute.params });
    },

    verificationEmail: async ({ commit, dispatch }, payload) => {
        const userInfo = await registrationService.verifyEmail(payload);

        if (userInfo === 'EMAIL_VERIFICATION_TOKEN_DOES_NOT_EXIST') throw new Error();

        dispatch('createNotification', { message: 'You are successfully registered' });

        commit(types.SET_LOGGED_IN, true);
        commit(types.SET_USER_INFO, userInfo);

        UserPermissions.setUserInfoToLocalStorage(userInfo);
    },

    verificationUserInfo: async ({ commit }, payload) => {
        commit(types.SET_LOGGED_IN, true);
        commit(types.SET_USER_INFO, payload);

        UserPermissions.setUserInfoToLocalStorage(payload);

        router.push({ name: 'LAYOUT', params: router.currentRoute.params })
    },

    verificationChangeEmail: async ({ dispatch }, payload) => {
        await registrationService.verifyChangeEmail(payload);

        dispatch('createNotification', { message: 'Your email has been changed' });
    },

    resendConfirmRegistration: async ({ dispatch }, payload) => {
        await registrationService.resendConfirmRegistration(payload);

        dispatch('createNotification', { message: 'Your verification email is on way' });
    },

    sendEmailForChangePassword: async ({ dispatch }, payload) => {
        await registrationService.sendEmailForChangePassword(payload);

        dispatch('createNotification', { message: 'If account exists, an email will be sent with further instructions' });
    },

    sendNewPassword: async ({ commit, dispatch }, payload) => {
        await registrationService.sendNewPassword(payload);

        dispatch('createNotification', { message: 'Password has been changed.' });
        commit(types.CHANGE_LOGIN_FORM, 'sign-in-form')
    },

    logout: async ({ commit }) => {
        await authenticationService.logout();

        localStorage.removeItem('activity-info');
        UserPermissions.removeUserInfoFromLocalStorage();

        commit(types.SET_LOGGED_IN, false);
        commit(types.RESET_STATE, initialState);

        router.push({ name: 'LOGIN', params: router.currentRoute.params })
    },

    refreshToken: async ({ commit }) => {
        const userInfo = UserPermissions.getUserInfoFromLocalStorage();

        if(userInfo) {
            const userInfoRefresh = await authenticationService.refreshToken(userInfo.expirationToken);

            UserPermissions.removeUserInfoFromLocalStorage();
            UserPermissions.setUserInfoToLocalStorage(userInfoRefresh);
            commit(types.SET_USER_INFO, userInfoRefresh);
        } else {
            router.push({ name: 'LOGIN', params: router.currentRoute.params })
        }
    },

    facebookLogIn: async () => {
        const url = await authenticationService.facebookAuthentication();

        window.location.href = `${url}`;
    },

    googleLogIn: async () => {
        const url = await authenticationService.googleAuthentication();

        window.location.href = `${url}`;
    },

    getSchoolInfo: async({ commit }) => {
        const schoolInfo = await authenticationService.getSchoolInfo();

        commit(types.SET_SCHOOL_INFO, schoolInfo);
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/authentication/actions.js